// Basic
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import DetailsGrid from '@/common-utils/components/renders/detailsGrid/DetailsGrid';
// Common
import RenderSimConsumptionChart from '../dataUnit/RenderSimConsumptionChart';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import simGroupFields from '../../fields/simGroupFields';
import { useEffect, useState } from 'react';
import getTranslatedText from '@/common-utils/functions/getTranslatedText';
import { nsSimCard } from '@/app/i18n/namespaces';
import { useTranslation } from 'react-i18next';

/**
 * @param root0
 * @param root0.simGroup
 * @returns {JSX} SimGroupDetails
 */
function SimGroupDetails({ simGroup }) {

    // Lang
    const { i18n } = useTranslation();
    const lang = i18n.resolvedLanguage;

    // Store
    const { permissions: userPermissions } = useSessionStore(s => s.session) ?? {};

    // State
    const [data, setData] = useState({});
    const [groupDataLimit, setGroupDataLimit] = useState(null);

    // Hooks
    useEffect(() => {
        const dataValue = getObjectAttributeFromStringKey(simGroup, generateNestedFieldAccessor(simGroupFields.SIM_OFFER.DATA));
        const dataUnit = getObjectAttributeFromStringKey(simGroup, generateNestedFieldAccessor(simGroupFields.SIM_OFFER.DATA_UNIT));

        if (simGroup) {
            setData({ ...simGroup, [simGroupFields.TARIFF_DATA.key]: `${dataValue} ${getTranslatedText(`units.${dataUnit}`, nsSimCard)}` });
            setGroupDataLimit(
                simGroup[simGroupFields.TOTAL_ACTIVATED_SIMS.key] *
                getObjectAttributeFromStringKey(simGroup, generateNestedFieldAccessor(simGroupFields.SIM_OFFER.DATA))
            );
        }
    }, [simGroup, lang]);

    const detailsKeys = {
        ORGANIZATION: simGroupFields.ORGANIZATION,
        PROVIDER: simGroupFields.PROVIDER,
        TARIFF_DATA: simGroupFields.TARIFF_DATA
    };
    const dataUsage = getObjectAttributeFromStringKey(simGroup, generateNestedFieldAccessor(simGroupFields.DATA_USAGE));

    return (
        <div className='p-2' >
            <DetailsGrid
                data={data}
                fields={detailsKeys}
                permissions={userPermissions}
                showEmptyFields={false}
            />
            {!!dataUsage.length &&
                <RenderSimConsumptionChart
                    data={dataUsage}
                    simOffer={
                        {
                            tariffData: groupDataLimit,
                            tariffDataUnit: getObjectAttributeFromStringKey(simGroup, generateNestedFieldAccessor(simGroupFields.SIM_OFFER.DATA_UNIT))
                        }
                    }
                />
            }
        </div >
    );
}

SimGroupDetails.propTypes = {
    simGroup: PropTypes.object
};

export default SimGroupDetails;